import AutoComplete from './auto-complete.vue'
export default AutoComplete
